// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/documents.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/documents/documents.js';

mount([g0]);
